<template>
  <ReviewSection
    v-bind="$attrs"
    :key="forcedRerender"
    @hydrated="
      () => {
        unWatchComponentRefresh?.(); // destroy watcher if component is already hydrated
      }
    "
  />
</template>
<script lang="ts" setup>
import { defineLazyVisibleHydratedComponent } from '@nuxt-common/media-card-large/app/modules/lazy-hydration';
import useTriggerComponentRefreshOnce from '../composables/useTriggerComponentRefreshOnce';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';

defineOptions({
  inheritAttrs: false,
});

const { forcedRerender, unWatchComponentRefresh, setComponentRefreshWatcher } = useTriggerComponentRefreshOnce();
const { isConsolidatedThirdVariantFlag } = useProductFlags();
const { isShopTheSetExpEnabled } = useFeatureEligibility();

if (isConsolidatedThirdVariantFlag || isShopTheSetExpEnabled) {
  const selectedProdId = useSelectedMemberId();
  setComponentRefreshWatcher(() => selectedProdId.value);
}

const ReviewSection = defineLazyVisibleHydratedComponent(() => import('~/modules/reviews/components/ReviewSection.vue'));
</script>
